import React, {useState, useEffect, useCallback,useContext} from 'react';
import api from '../contexts/BaseUrl'
import './Home.css'
import LeftPanel from '../components/LeftPanel';
import Loading from '../components/Loading';
import { UnitShadeContext } from "../contexts/UnitShadeContext";

export default function Home(){

    const token = JSON.parse(localStorage.getItem('auth')).token;
    const [isLoading,setIsLoading] = useState(false);
    const [expenseData,setExpenseData] = useState([]);
    const [totalIncome,setTotalIncome] = useState(0);
    const { unitShadeNo } = useContext(UnitShadeContext);

    const fetchHomeData = useCallback( async () =>{
        setIsLoading(true);
        await api.get(`expenses/total-expenses-by-type?unitShadeId=${unitShadeNo}`,{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setExpenseData(response.data);
            setIsLoading(false);
        }).catch(err =>{
            setIsLoading(false);
        })
    },[token,unitShadeNo])

    const fetchTotalIncome = useCallback( async () =>{
        setIsLoading(true);
        await api.get(`expenses/total-income?unitShadeId=${unitShadeNo}`,{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setTotalIncome(response.data);
            setIsLoading(false);
        }).catch(err =>{
            setIsLoading(false);
        })
    },[token,unitShadeNo])

    useEffect(() =>{
        fetchHomeData();
        fetchTotalIncome();
    },[fetchHomeData,fetchTotalIncome])

    return(
        <div className='homePage'>
            <LeftPanel
                tabName='home'
            />
            <div id='rightPanel'>
                <div id='rightPanelContent'>
                    {isLoading ? 
                    <div style={{marginTop:'100px'}}>
                        <Loading /> 
                    </div>
                    :
                    <>
                    <div id='boxHeadingIncome'>Income</div>
                    <div id='boxContent'>
                        <div id='boxItemIncome'>
                            <div id='header'>Total Income</div>
                            <div id='headerContent'>Tk {totalIncome}</div>
                        </div>
                    </div>
                    <div id='boxHeading'>Expenses</div>
                    <div id='boxContent'> 
                        {expenseData.map((item,index) => (
                            <div id='boxItem' key={index}>
                                <div id='header'>{item.expenseTypeName} Expenses</div>
                                <div id='headerContent'>Tk {item.totalAmount}</div>
                            </div>
                        ))}
                    </div>
                    </>
                    }
                
                    
                </div>
            </div>
        </div>
    )
}